import { Trans, useTranslation } from 'react-i18next';
import { Link as LinkIcon } from '@mui/icons-material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CopyButton from 'shared/components/buttons/copy-button/copy-button';
import PopUp from 'shared/components/pop-up/pop-up';

import { useGatewaysContextProvider } from 'features/gateway/context/gateway-provider';
import { GatewayType } from 'features/gateway/domain/models/gateway-type';
import useGatewaySettingsIoTEdgeClient from 'features/gateway/hooks/gateway-settings-iot-edge-client-hook';
import styles from 'features/gateway/views/gateway-details/gateway-settings/gateway-settings-clients/gateway-settings-client.module.scss';

const GatewaySettingsIoTEdgeClient = () => {
  const { t } = useTranslation('gateway');

  const { gatewayDetailsHook } = useGatewaysContextProvider();

  const {
    deviceId,
    ioTEdgeConnectionString,
    generateIoTEdgeConnectionStringIsLoading,
    isGenerateConfirmationOpen,
    defaultIoTEdgeConnectionString,
    generateIoTEdgeConnectionString,
    submitGenerateIoTEdgeConnectionString,
    closeGenerateConfirmationPopup,
  } = useGatewaySettingsIoTEdgeClient();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.infoItem}>
          <Typography variant="subtitle1">{t('details.settings.ioTEdgeDeviceIdLabel')}:</Typography>
          <Typography variant="subtitle1">
            {gatewayDetailsHook.currentSelectedGateway?.type === GatewayType.IoTEdgeMediaServerGatewayCluster
              ? t('details.settings.centralSupportGatewayConnectionStringLabel')
              : t('details.settings.ioTEdgeConnectionStringLabel')}
            :
          </Typography>
        </div>
        <div className={styles.infoItem}>
          <div className={styles.secret}>
            <Typography variant="subtitle1">{deviceId ?? '-'}</Typography>
            {deviceId !== undefined && <CopyButton contentToCopy={deviceId} />}
          </div>
          <div className={styles.secret}>
            <Typography variant="subtitle1">{ioTEdgeConnectionString}</Typography>
            {ioTEdgeConnectionString !== defaultIoTEdgeConnectionString && <CopyButton contentToCopy={ioTEdgeConnectionString} />}
          </div>
        </div>
      </div>
      {gatewayDetailsHook.viewingMode === 'viewing' &&
        (ioTEdgeConnectionString === defaultIoTEdgeConnectionString ? (
          <Button
            variant="outlined"
            onClick={generateIoTEdgeConnectionString}
            startIcon={<LinkIcon />}
            loading={generateIoTEdgeConnectionStringIsLoading}
            loadingPosition="start"
            className={styles.secretButton}
            data-testid="generate-secret-button"
          >
            {t('details.settings.clientSecret.generateButton')}
          </Button>
        ) : (
          <Typography variant="subtitle1">{t('details.settings.clientSecret.warningIoTEdge')}</Typography>
        ))}
      <PopUp
        isOpen={isGenerateConfirmationOpen}
        title={t('details.settings.clientSecret.confirmation.title')}
        body={<Trans t={t} i18nKey="details.settings.clientSecret.confirmation.bodyText" />}
        primaryButtonText={t('details.settings.clientSecret.confirmation.confirmButton')}
        secondaryButtonText={t('details.settings.clientSecret.confirmation.cancelButton')}
        handleOnClose={closeGenerateConfirmationPopup}
        secondaryButtonAction={closeGenerateConfirmationPopup}
        primaryButtonAction={submitGenerateIoTEdgeConnectionString}
      />
    </>
  );
};

export default GatewaySettingsIoTEdgeClient;
